import { isValidTenantTimezone } from '../utils/dayjs-config';

export const shouldUseOperationalTimezone = (
  pathname: string,
  authenticated: boolean,
): boolean => authenticated && (pathname === '/admin' || pathname.startsWith('/admin/'));

const timezoneFrom = (value: unknown): string | undefined => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return undefined;
  const timezone = (value as Record<string, unknown>).timezone;
  return typeof timezone === 'string' && isValidTenantTimezone(timezone) ? timezone : undefined;
};

export const selectOperationalTenantTimezone = (
  businessInfo: unknown,
  tenantMetadata: unknown,
): string | undefined => timezoneFrom(businessInfo) ?? timezoneFrom(tenantMetadata);
